/*
 * @Author: huangyf huangyf@efly.cc
 * @Date: 2022-01-19 18:00:27
 * @LastEditors: huangyf huangyf@efly.cc
 * @LastEditTime: 2024-08-09 14:34:09
 * @FilePath: \agent\manage\main\src\store\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    router: {},
    userInfo: '',
    systemInfo: '',
  },
  mutations: {
    setUserInfo(context, userInfo) {

			context.userInfo = userInfo;
		},
    setSystemInfo(context, systemInfo) {
			context.systemInfo = systemInfo;
		},
  },
  actions: {
  },
  modules: {
  },

});
